export type SelectedLocationsSet = Set<string>

export type OnSelectedLocationsChange = (selectedIds: SelectedLocationsSet) => void

export enum LocationSelectorActions {
  Add = 'add',
  Remove = 'remove',
}
